import React from "react"
import className from "classnames"

import iconArtist from "@images/shared/service_site/icon/Artist.svg"
import iconIdol from "@images/shared/service_site/icon/Idol.svg"
import iconVTuber from "@images/shared/service_site/icon/VTuber.png"
import iconActor from "@images/shared/service_site/icon/Actor.svg"
import iconYouTuber from "@images/shared/service_site/icon/YouTuber.svg"
import iconVoiceActor from "@images/shared/service_site/icon/VoiceActor.svg"
import iconCharacter from "@images/shared/service_site/icon/Character.png"
import iconAthlete from "@images/shared/service_site/icon/Athlete.svg"

type PropTypes = {
  text1: string
  text2: string
}

const cards = [
  {name: "Artist", icon: iconArtist},
  {name: "Idol", icon: iconIdol},
  {name: "VTuber", icon: iconVTuber},
  {name: "Actor", icon: iconActor},
  {name: "YouTuber", icon: iconYouTuber},
  {name: "VoiceActor", icon: iconVoiceActor},
  {name: "Character", icon: iconCharacter},
  {name: "Athlete", icon: iconAthlete},
]

const ServiceSiteIndex: React.FC<PropTypes> = ({text1, text2}) => {
  const [__bg, __bgSet] = React.useState("")

  return (
    <div className={className("Root__info", `Root__info__${__bg}`)}>
      <h2 className="Root__info__h2">
        {text1}
        <br />
        {text2}
      </h2>
      <div className="Root__info__img">
        {cards.map((card, i) => {
          return (
            <div
              className="Root__info__img__icon"
              onMouseEnter={() => __bgSet(card.name)}
              onMouseLeave={() => __bgSet("")}
              key={i}
            >
              <img src={card.icon} className="Root__info__img__icon__img" />
              <span className="Root__info__img__icon__span">{card.name}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ServiceSiteIndex
